// import React from "react";
// import { Check } from "react-bootstrap-icons";
// import "./AboutSection.css";
// import { Link } from "react-router-dom";
// // Import your real images here
// import ampp from "../../../asstes/logo/AMPP Licensee_4C_horizonta.png"; // AMPP logo
// import agep from "../../../asstes/Home/agep.png"; // AGEP logo
// import abtsetion from "../../../asstes/Home/about.png"

// const AboutSection = () => {
//   return (
//     <section className="about-section container py-5">
//       <div className="row align-items-center">
//         {/* Left Column - Image & Logos */}
//         <div className="col-lg-6 text-center mb-4 mb-lg-0">
//           <div className="about-image-wrapper">
//             {/* Main image */}
//             <img
//               src={abtsetion}
//               alt="Training Session"
//               className="main-about-img"
//             />

//             {/* Logos under main image */}
//             <div className="logo-wrapper">
//               <div className="logo-card">
//                 <img src={ampp} alt="AMPP Logo" className="logo-img" />
//               </div>
//               <div className="logo-card">
//                 <img src={agep} alt="AGEP Logo" className="logo-img" />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Text Content */}
//         <div className="col-lg-6 about-text p-5">
//           <h2 className="about-title">About ICCI</h2>
//           <p>
//             ICCI, an initiative of AGEP, is India’s AMPP-authorized licensee,
//             offering globally recognized training and certification courses in
//             corrosion control comprising of Coating Inspection, Cathodic
//             Protection, and Concrete Coating Inspection – delivered to
//             AMPP’s highest international standards.
//           </p>
//           <p>
//             Backed by our affiliation with AMPP, ICCI delivers world-class
//             training with practical learning, empowered professionals to
//             advance their career while protecting critical assets.
//           </p>

//           <h5 className="text-small">Why choose ICCI?</h5>
//           <ul className="about-list mb-3">
//             <li>
//               <Check className="check-icon" />{" "}
//               <strong>Exclusive AMPP Licensee</strong> – India’s only
//               organization authorized to deliver AMPP programs in CP and CCI.
//             </li>
//             <li>
//               <Check className="check-icon" />{" "}
//               <strong>Fulfilling Industry Demand</strong> – Bridging the gap for
//               certified corrosion and coating experts.
//             </li>
//             <li>
//               <Check className="check-icon" />{" "}
//               <strong>High-Growth Opportunities</strong> – Tapping into Asia’s
//               booming industrial and infrastructure sectors.
//             </li>
//             <li>
//               <Check className="check-icon" />{" "}
//               <strong>Future-Ready Skills</strong> – Training talent to step
//               into key roles as veterans move up.
//             </li>
//             <li>
//               <Check className="check-icon" />{" "}
//               <strong>Career-Focused Mission</strong> – Helping you build a
//               strong future in corrosion control.
//             </li>
//           </ul>

//           <button className="learn-btn text-dark">
//             <Link
//               to="https://agepindia.com" target="_blank"
//               style={{ textDecoration: "none", color: "#fef5ee" }}
//             >
//               Learn more about AGEP India →
//             </Link>
//           </button>
//         </div>
//       </div>

//       {/* Bottom Section - Explore Certification */}
//       <div className="certification-section mt-5">
//         <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
//           <div>
//             <h3 className="cert-title">Explore Our Certification Programs</h3>
//             <p className="cert-text">
//               Gain industry-recognized credentials through AMPP-authorized
//               training, designed to equip you with the skills and expertise to
//               excel in corrosion control, coating inspection, and asset
//               protection.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutSection;
import React from "react";
import { Check } from "react-bootstrap-icons";
import "./AboutSection.css";
// import { Link } from "react-router-dom";

import abtsetion from "../../../asstes/Home/ecaabout.png";

const AboutSection = () => {
  return (
    <section className="container about-section  py-5">
      <div className="row align-items-center">
        {/* ✅ Left Column - ONLY ONE IMAGE */}
        <div className="col-lg-6 text-center mb-4 mb-lg-0">
          <div className="about-image-wrapper">
            <img
              src={abtsetion}
              alt="Training Session"
              className="main-about-img"
            />
          </div>
        </div>

        {/* ✅ Right Column - TEXT MATCHING YOUR IMAGE */}
        <div className="col-lg-6 about-text p-lg-5">
          <h2 className="about-title">About EAC International LLC</h2>

          <p>
            EAC International LLC is one of the global leader in corrosion control, asset
            protection, and professional training. We deliver innovative,
            standards-driven solutions that enhance asset life, operational
            safety, and long-term performance across industries worldwide.
          </p>

          <p className="fw-semibold">
            Through our training partner, AGEP, we offer globally recognized
            AMPP certification programs, including:
          </p>

          <ul className="about-list mb-3">
            <li>
              <Check className="check-icon" />
              <span>Coating Inspection (CIP Level 1, 2 & 3)</span>
            </li>
            <li>
              <Check className="check-icon" />
              <span>Cathodic Protection (CP Level 1 & 2)</span>
            </li>
            <li>
              <Check className="check-icon" />
              <span>Concrete Coating Inspection (CCI Level 1 & 2)</span>
            </li>
          </ul>

          <p>
            Each program follows AMPP’s global standards, blending theory and
            hands-on training to develop skilled corrosion and coating
            professionals.
          </p>

          <p>
            Beyond training, EAC delivers engineering and inspection services
            including{" "}
            <span className="fw-semibold">
              corrosion mitigation, coating audits, QA/QC oversight, technical
              documentation, ITPs, and coating system validation across oil &
              gas, marine, infrastructure, energy, and manufacturing sectors.
            </span>
          </p>

          <p>
            With certified experts and decades of experience, we provide
            reliable solutions that protect critical assets and support industry
            growth.
            <span className="fw-semibold">
              Protecting assets. Advancing professionals. Elevating global
              standards.
            </span>
          </p>

          {/* <button className="learn-btn">
            <Link
              to="https://agepindia.com"
              target="_blank"
              style={{ textDecoration: "none", color: "#ffffff" }}
            >
              Learn more →
            </Link>
          </button> */}
        </div>
      </div>
      {/* Bottom Section - Explore Certification */}
      <div className="certification-section mt-md-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div>
            <h3 className="cert-title">Explore AMPP Certification Programs Delivered in India</h3>
            <p className="cert-text">
              Gain industry-recognized credentials through{" "}
              <span className="fw-semibold">AMPP-authorized training,</span> designed to equip you with
              the skills and expertise to excel in corrosion control, coating
              inspection, and asset protection.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
